import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, IconButton } from "@mui/material";
export const PlainAccountDescription = ({ description, onStartEdit, }) => {
    return (_jsx(_Fragment, { children: _jsxs("div", { style: { display: "flex" }, children: [_jsx(Typography, { variant: "body1", noWrap: true, title: description, onClick: onStartEdit, sx: {
                        cursor: "pointer",
                        color: "var(--brandColourPrimary)",
                        fontSize: "1.3rem",
                        fontWeight: 500,
                    }, children: description }), _jsx(IconButton, { className: "edit-desc-title", "aria-label": "edit", title: "Edit Account Name", onClick: onStartEdit, id: "edit", children: _jsx(EditIcon, {}) })] }) }));
};
